/* eslint-disable @typescript-eslint/no-explicit-any */
import { CriminalFormPopup } from "@/components/CriminalFormPopup"
import { FileUpload } from "@/components/file-upload"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
// import { d34 } from "@/data/sampleDoc"
import { 
  // useEffect,
  useState 
} from "react"

function UploadReport() {
  const [showGoondaActForm, setShowGoondaActForm] = useState(false)
  const [extractedData, setExtractedData] = useState<any>(null)

  const handleFileProcessed = (data: any) => {
    setExtractedData(data)
    setShowGoondaActForm(true)
  }
  // useEffect(() => {
  //   handleFileProcessed(d34)
  // },[])
  return (
    <>
      <CriminalFormPopup open={showGoondaActForm} onOpenChange={setShowGoondaActForm} data={extractedData?.goonda_act_report} />
      <Card className="border border-gray-200 m-10">
        <CardHeader>
          <CardTitle className="text-black">Upload Report</CardTitle>
          <CardDescription className="text-gray-600">
            Upload police documents for OCR processing and form generation
          </CardDescription>
        </CardHeader>
        <CardContent>
          <FileUpload onFileProcessed={handleFileProcessed} docType={'3_4'} />
        </CardContent>
      </Card>
    </>
    
  )
}

export default UploadReport